import { LegalContainer } from './styles';
import { useSelector } from 'react-redux';
import { getLanguage } from '@store/slices/configSlice';
import { GERMAN_TERMS_CONTENT, ENGLISH_TERMS_CONTENT } from './data';

const LegalContent = () => {
  const language = useSelector(getLanguage);

  return (
    <LegalContainer>
      {language === 'de' ? <GERMAN_TERMS_CONTENT /> : <ENGLISH_TERMS_CONTENT />}
    </LegalContainer>
  );
};

export default LegalContent;
